import React, { useLayoutEffect, useRef } from 'react';

// Keep DOM/keyboard order while packing each card into the shortest column.
export default function MasonryGrid({ children }) {
  const gridRef = useRef(null);

  useLayoutEffect(() => {
    const grid = gridRef.current;
    const items = Array.from(grid.children);
    let frame;
    let previousColumns = 0;
    let previousWidth = grid.getBoundingClientRect().width;

    const arrange = () => {
      const style = getComputedStyle(grid);
      const columns = Number(style.getPropertyValue('--masonry-columns')) || 1;
      if (columns !== previousColumns) {
        // Remove obsolete column positions before measuring at a new breakpoint.
        items.forEach((item, index) => { item.style.gridColumn = String(index % columns + 1); });
        previousColumns = columns;
      }
      const gap = parseFloat(style.columnGap) || 0;
      const heights = Array(columns).fill(0);
      // Read sizes before writing placement to avoid repeated layout work.
      const sizes = items.map(item => Math.ceil(item.firstElementChild.getBoundingClientRect().height));
      items.forEach((item, index) => {
        const column = heights.indexOf(Math.min(...heights));
        item.style.gridColumn = String(column + 1);
        item.style.gridRow = `${heights[column] + 1} / span ${sizes[index] + gap}`;
        heights[column] += sizes[index] + gap;
      });
    };

    const observer = new ResizeObserver(entries => {
      const width = grid.getBoundingClientRect().width;
      if (entries.some(entry => entry.target !== grid) || width !== previousWidth) {
        previousWidth = width;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(arrange);
      }
    });
    arrange();
    observer.observe(grid);
    items.forEach(item => observer.observe(item.firstElementChild));
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, [children]);

  return <div className="question-grid masonry-grid" ref={gridRef}>
    {React.Children.map(children, child => <div className="masonry-item">{child}</div>)}
  </div>;
}
